import { Button, GoogleColorIcon } from '@iheartjane/reefer';
import type { ButtonProps } from '@iheartjane/reefer';

interface GoogleButtonProps extends ButtonProps {
  label: string;
  onClick: () => void;
}

export const GoogleSignInButton = ({
  label,
  onClick,
  ...buttonProps
}: GoogleButtonProps) => {
  return (
    <Button
      full
      label={label}
      onClick={onClick}
      startIcon={<GoogleColorIcon size="sm" color={null} />}
      variant="tertiary"
      {...buttonProps}
    />
  );
};
